export default __webpack_public_path__ + "static/media/header.7bdc74f1.png";